var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocsCheck = function SvgDocsCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 1.25H4.688c-.864 0-1.563.7-1.563 1.563v14.375c0 .862.7 1.562 1.563 1.562h10.625c.862 0 1.562-.7 1.562-1.562v-6.563A3.125 3.125 0 0 0 13.75 7.5h-1.562a1.563 1.563 0 0 1-1.563-1.562V4.375A3.125 3.125 0 0 0 7.5 1.25m5.508 9.113a.624.624 0 1 0-1.016-.726l-2.697 3.775-1.353-1.354a.625.625 0 0 0-.884.884l1.875 1.875a.625.625 0 0 0 .95-.079z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.81 1.514a4.36 4.36 0 0 1 1.065 2.861v1.563c0 .172.14.312.313.312h1.562a4.36 4.36 0 0 1 2.862 1.066 8.14 8.14 0 0 0-5.802-5.802"
  })));
};
export default SvgDocsCheck;